import React from 'react';
import { useUser } from '@lore/auth';
import useAccountSetup from '@/hooks/useAccountSetup';
import StreamlinedLayout from './_streamlined/Layout';
import LegacyLayout from './LegacyLayout';

export default function Layout() {
  const currentUser = useUser();
  const {
    isFetching: isFetchingAccountSetup,
    streamlinedAccountFlowEnabled
  } = useAccountSetup(currentUser);

  if (isFetchingAccountSetup) {
    return null;
  }

  if (streamlinedAccountFlowEnabled) {
    return <StreamlinedLayout />;
  }

  return <LegacyLayout currentUser={currentUser} />;
};
